module.exports = __webpack_public_path__ + "img/box-silhouette.8526273e.webp";